/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./offitask.vue?vue&type=template&id=2f816f51&scoped=true"
import script from "./offitask.vue?vue&type=script&lang=js"
export * from "./offitask.vue?vue&type=script&lang=js"
import style0 from "./offitask.vue?vue&type=style&index=0&id=2f816f51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f816f51",
  null
  
)

export default component.exports